import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideSolAuthentication,
  provideSolComponents,
  provideSolDebug,
  provideSolHttpClient,
  provideSolLocale,
  provideSolNavigation,
  provideSolStorage,
  provideSolTheme,
} from '@sol/components';
import { environment } from '../environments/environment';
import * as packageJson from '../../package.json';
import { apps } from './apps';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    ...provideSolHttpClient(),
    provideSolComponents(packageJson.version),
    provideSolDebug(environment.ENV),
    provideSolAuthentication({
      url: environment.KEYCLOAK_URL,
      realm: environment.KEYCLOAK_REALM,
      clientId: environment.KEYCLOAK_CLIENT_ID,
    }),
    provideSolStorage(environment.APP),
    provideSolTheme(),
    provideSolNavigation(apps, routes, environment),
    provideSolLocale(['sol-catalog', 'sol-components']),
  ],
};
